import React from "react";
import {
    Paper,
    Chip,
    FormControl,
    FormLabel,
    Tooltip,
    Box
} from "@mui/material";

function ChatbotSuggestions({ suggestions, setInput }) {
    const [selectedChip, setSelectedChip] = React.useState('');

    const handleChipClick = (chip) => {
        setSelectedChip(chip);
        setInput(chip); // set the input to the selected chip value
    };

    return (
        <>
        {suggestions && suggestions.length > 0 && (
        <Box
            
        >
            <FormControl>
               <div className="text-[10px]"><i>You may additionally ask</i></div>
                <div>
                    {suggestions.map((suggestion, idx) => (
                        <Tooltip key={idx} title={suggestion} arrow>
                            <Chip
                                label={suggestion}
                                clickable
                                color={selectedChip === suggestion ? 'primary' : 'default'}
                                onClick={() => handleChipClick(suggestion)}
                                sx={{
                                    marginY: 0.5,
                                    maxWidth: 250,  // limit the width of the chip
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    fontSize: '12px',
                                    whiteSpace: 'nowrap',
                                    backgroundColor: selectedChip === suggestion ? undefined : '#D1E3E7',  // lighter version of #376B7E
                                }}
                            />
                        </Tooltip>
                    ))}
                </div>
            </FormControl>
        </Box>
        )}
        </>
    );
}

export default ChatbotSuggestions;
